var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-container"},_vm._l((_vm.addressList),function(address){return _c('el-tag',{key:address.id,staticClass:"address-tag-wrapper"},[_c('address-tag',{attrs:{"address":address,"trigger":"click"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }